import React, { FC, memo } from "../../../lib/teact/teact";
import { User } from "./AdminTypes";

type OwnProps = {
    user: User;
    index:number;
}

const UserItem: FC<OwnProps> = ({
    user,
    index,
}) => {
    return (
        <div className="common-container-col">
            <div >
                <span style='font-weight:bold;'>{index+1}</span>
                <span style='font-weight:bold;'>{user.username}</span>
                <span>{user.expDate.substring(0, 10)}</span>
                <span>{user.userId}</span>
            </div>
            {user.userGroupRole != "user" &&
                <>
                    <div> <span> Số tk con: {user.totalChildren} </span></div>
                    <div> <span> cấp: {user.sumCap} </span></div>
                    <div> <span> huỷ: {user.sumHuy} </span></div>
                    <div> <span> thanh toán: {user.sumTt} </span></div>
                </>
            }
        </div>
    )
}

export default memo(UserItem);